const isJest = process?.env?.JEST_WORKER_ID !== undefined

export { isJest }
